import React from "react";
import * as Styled from "./NewProfileAlert.styled";
import { TextInput } from "../../../libs";
import { BaseButton } from "../../../libs";
import { useFormik } from "formik";
import * as Yup from "yup";

export const NewProfileAlert: React.FC<{
    onClose: () => void;
    handleSaveProfile: (name: string) => void;
    initialProfileName?: string;
    isEdit?: boolean;
}> = ({ onClose, handleSaveProfile, initialProfileName = "", isEdit = false }) => {
    const formik = useFormik({
        initialValues: {
            profile_name: initialProfileName
        },
        validationSchema: Yup.object({
            profile_name: Yup.string()
                .required("This is a mandatory field. Please complete it before continuing.")
                .test("len", "Must be less than 100 characters", (val) => val?.length <= 100)
        }),
        onSubmit: (values) => {
            handleSaveProfile(values.profile_name);
            onClose();
        }
    });
    return (<Styled.NewProfileAlertContainer>
        <Styled.NewProfileAlertTitle>{isEdit ? "Edit Profile" : "New Profile"}</Styled.NewProfileAlertTitle>
        <TextInput
            fieldName="profile_name"
            hasError={!!formik.errors.profile_name}
            fieldLabel="Profile Name*"
            placeholder="Enter profile name"
            inputLimit={100}
            fieldValue={formik.values.profile_name}
            onChangeHandler={formik.handleChange}
        />
        <Styled.ErrorText>{formik.errors.profile_name}</Styled.ErrorText>
        <Styled.ButtonsContainer>
            <BaseButton size="sm" variant="secondary" onClick={onClose}>Cancel</BaseButton>
            <BaseButton size="sm" variant="primary" onClick={formik.submitForm}>{isEdit ? "Save" : "Create"}</BaseButton>
        </Styled.ButtonsContainer>
    </Styled.NewProfileAlertContainer>);
}
